export default {
  name: 'NotFound',
  data() {
    return {
      countdown: 3,
      timer: null,
    };
  },
  mounted() {
    this.timer = setInterval(() => {
      this.countdown -= 1;
      if (this.countdown <= 0) {
        clearInterval(this.timer);
        this.$router.push('/');
      }
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
